import classNames from "classnames";
import { StarRating } from "./StarRating";

interface RatingBadgeProps {
  eligible?: boolean;
  rating?: number;
  starRating?: number;
}

export function RatingBadge(props: RatingBadgeProps) {
  return (
    <div>
      <div className={classNames("tw:w-full tw:rounded-xl tw:bg-gray-50")}>
        <div className={classNames("tw:px-4")}>
          {!props.eligible ? (
            <div className="tw:flex tw:items-center tw:content-center tw:justify-center tw:py-8">
              <span className="tw:text-xl">{props.starRating}</span>
            </div>
          ) : (
            <div className="tw:flex tw:flex-row tw:justify-between tw:items-center tw:py-4">
              <StarRating
                rating={props.starRating ? Number(props.starRating) : 0}
                width={150}
                height={0}
              />
              <div
                className={classNames(
                  "tw:mt-0 tw:font-sofia-pro tw:font-normal tw:text-[2rem] tw:lg:text-[3rem]",
                  "tw:text-cn-search-bold",
                )}
              >
                {`${(+(props.rating ?? 0)).toFixed(0)}%`}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
